// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedCategories_container__Dgfvj","catListContainer":"RelatedCategories_catListContainer__vtwPB","catBtnStyles":"RelatedCategories_catBtnStyles__hFJ33"};